const AUTO_CLOSE_DELAY = 5000;

function scrollIntoCenter(element) {
    const rect = element.getBoundingClientRect();
    const offset = Math.max((window.innerHeight - rect.height) / 2, 0);
    const top = Math.max(rect.top + window.scrollY - offset, 0);

    window.scrollTo({ top, behavior: 'smooth' });
}

function whenLoaded(callback) {
    if (document.readyState === 'complete') {
        callback();
        return;
    }
    window.addEventListener('load', callback, { once: true });
}

function createController(message) {
    let timer = null;

    const close = () => {
        if (timer) clearTimeout(timer);
        timer = null;
        document.removeEventListener('pointerdown', onPointerDown);
        message.classList.remove('is-visible');
    };

    const onPointerDown = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (target?.closest('[data-contact-thanks]') === message) return;
        close();
    };

    const open = () => {
        if (timer) clearTimeout(timer);
        message.classList.add('is-visible');
        scrollIntoCenter(message);
        timer = setTimeout(close, AUTO_CLOSE_DELAY);
        document.addEventListener('pointerdown', onPointerDown);
    };

    return { open };
}

export function ThanksMessage() {
    document.addEventListener('DOMContentLoaded', () => {
        const messages = document.querySelectorAll('[data-contact-thanks]');
        if (!messages.length) return;

        const controllers = new WeakMap();

        messages.forEach((message) => {
            const controller = createController(message);
            controllers.set(message, controller);

            if (message.classList.contains('is-visible')) {
                whenLoaded(controller.open);
            }
        });

        document.addEventListener('contact-form:success', (event) => {
            const message = event.target.querySelector('[data-contact-thanks]');
            if (message) controllers.get(message)?.open();
        });
    });
}
